export const SET_ACCOUNTS = 'view/Accounts/SET_ACCOUNT';
export const ADD_ACCOUNT = 'view/Accounts/ADD_ACCOUNT';
export const REMOVE_ACCOUNT = 'view/Accounts/REMOVE_ACCOUNT';